module.exports = __webpack_public_path__ + "img/DNARepair-OVCA_10X_OC.3c808e26.png";